import '@assets/scss/style_tailwind.scss';
import 'react-toastify/dist/ReactToastify.css';
import '@root/instrument';

import { App } from '@components/App';
import { renderRootForContainerId } from '@conversed/ui/src/helpers/render';

renderRootForContainerId('root', <App />);
